/**
 * Libellés d'écran des notes reliées à un passage (C22 SP2, `VOCABULAIRE_ECRAN.md`).
 * L'écran dit « Relier à une note », « Notes reliées », « Relié à « Titre » » —
 * jamais « lien », « renvoi », « marque », ni un nom de champ. Testés contre `motsBannis`.
 */
export const NOTE_RELIEE_LABELS = {
  geste: 'Relier à une note',
  placeholder: 'Relier à une note…',
  boutonBarre: 'Note',
  section: 'Notes reliées',
  passage: 'Ce passage',
  relieA: (titre: string | number) => `Relié à « ${titre} »`,
  ouvrir: (titre: string | number) => `Ouvrir « ${titre} »`,
  relationGroupe: 'Ce que ce passage fait à la note',
  relations: { soutient: 'Soutient ou développe', oppose: 'S’oppose ou répond', suite: 'Fait suite' },
  relationsCible: { soutient: 'soutient cette note', oppose: 's’oppose à cette note', suite: 'fait suite à cette note' },
  // Le fil d'une note (C22 SP2 bis) : le verbe de la relation, jamais le mot « fil ».
  faitSuiteA: 'Fait suite à',
  suiviePar: 'Suivie par',
  /** Nom accessible du bandeau (lecteurs d'écran seulement). */
  suitesRegion: 'Notes qui se suivent',
  pourquoi: 'Pourquoi ?',
  pourquoiAide: 'Facultatif : ce qui relie ce passage à la note.',
  retirer: 'Retirer',
  retirerDe: (titre: string | number) => `Retirer « ${titre} » de ce passage`,
  retirerQuestion: 'Retirer cette note du passage ?',
  annuler: 'Annuler',
  terminer: 'Terminé',
  indisponible: 'Note indisponible',
  sansTitre: 'Note sans titre',
  chercher: 'Chercher une note',
  aucunResultat: 'Aucune note ne correspond.',
  selectionRequise: 'Sélectionnez d’abord un passage.',
  horsLigne: 'Sans connexion. Réessayez.',
  autresPassages: (n: string | number) => (Number(n) === 1 ? 'et 1 autre passage' : `et ${n} autres passages`),
  aideSousLaNote: 'Sélectionnez un passage pour le relier à un concept ou à une note. Touchez un passage surligné ou souligné pour voir ce qui le relie.',
  messages: {
    relie: (titre: string | number) => `Relié à « ${titre} »`,
    dejaRelie: (titre: string | number) => `Ce passage est déjà relié à « ${titre} ».`,
    retire: (titre: string | number) => `« ${titre} » retirée de ce passage`,
    precise: 'Enregistré',
  },
} as const;
